/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as rt from 'runtypes';
import { AbsoluteUri, Environment } from './basetypes';

export const Config = rt.Record({
  // Core
  environment: Environment,
  version: rt.String,
  domain: AbsoluteUri,

  // Config
  roadMapAPIUrl: AbsoluteUri,
  crimsonAppAPIUrl: AbsoluteUri,
  studentCenterAPIUrl: AbsoluteUri,
  pathfinderAPIUrl: AbsoluteUri,

  // Datadog
  datadogApplicationId: rt.String.optional(),
  datadogClientToken: rt.String.optional(),
  datadogSite: rt.String.optional(),
  datadogTunnelProxyUrl: rt.String.optional(),
  datadogVersion: rt.String,
  posthogApiKey: rt.String.optional(),
  posthogApiHost: rt.String.optional(),

  launchDarklyClientSideId: rt.String,
});
export type Config = rt.Static<typeof Config>;

export function getConfig(data: Record<string, string | undefined>): Config {
  const config: Config = {
    // Core
    environment: (data.ENVIRONMENT as Environment) ?? 'dev',
    version: data.VERSION ?? 'no-version',
    domain: data.DOMAIN as AbsoluteUri,

    // Config
    roadMapAPIUrl: data.ROADMAP_SERVICE_URL as AbsoluteUri,
    studentCenterAPIUrl: data.STUDENT_CENTER_SERVICE_URL as AbsoluteUri,
    crimsonAppAPIUrl: data.CRIMSON_APP_API_URL as AbsoluteUri,
    pathfinderAPIUrl: data.PATHFINDER_API_URL as AbsoluteUri,

    // Datadog
    datadogApplicationId: data.DD_APPLICATION_ID,
    datadogClientToken: data.DD_CLIENT_TOKEN,
    datadogSite: data.DD_SITE,
    datadogTunnelProxyUrl: data.DD_TUNNEL_PROXY_URL,
    datadogVersion: data.DD_VERSION ?? data.VERSION ?? 'no-version',
    posthogApiKey: data.POSTHOG_API_KEY,
    posthogApiHost: data.POSTHOG_API_HOST,

    launchDarklyClientSideId: data.LAUNCH_DARKLY_CLIENT_SIDE_ID ?? '6301ec6419c4f8119d710bc1',
  };

  try {
    return Config.check(config);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    let message = e.message;
    if (e?.details) {
      message = JSON.stringify(e.details, null, 2);
    }
    throw new Error(`Failed to load config: ${message}`);
  }
}

export default getConfig(window.process.env);
